/**
 * Logs a step in the registration process by sending a POST request to the backend.
 *
 * @param {string} registrationRandom - A unique identifier for the registration process.
 * @param {string} step - The current step in the registration process.
 * @param {string} [country=""] - The country associated with the registration (optional).
 * @param {string} [language=""] - The language of the certification (optional).
 * @param {string} [certificate=""] - The certificate associated with the registration (optional).
 * @param {string} [action="step"] - The action being logged (default is "step").
 * @param {string} [referrer=""] - The referrer information for the registration step (optional).
 * @param {string} [parameters=""] - The query string paramaneters as string (optional).
 * @throws {Error} Logs an error to the console if the fetch request fails.
 */
export function logStep(
  registrationRandom,
  step,
  country = "",
  language = "",
  certificate = "",
  action = "step",
  referrer = "",
  userAgent = "",
  parameters = ""
) {
  fetch(`${process.env.VUE_APP_BACKEND_URL}/registration/${process.env.VUE_APP_TENANT}/next-step`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      registrationRandom,
      step,
      country,
      language,
      certificate,
      action,
      referrer,
      userAgent,
      parameters,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data !== "ok") {
        console.error("Error logging step");
      }
    })
    .catch((err) => {
      console.error(err);
    });
}
